import React from 'react';
import { Link } from 'react-router-dom';
import './ISO31000.css';

const ISO31000 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">ISO 31000 Enterprise Risk Management System</h1>
            <h2 className="page-subtitle">ISO 31000 Enterprise Risk Management System: Strategic Assurance and Innovation</h2>
            <div className="page-text-content">
              <p>
                As NQC (Nova Quality Certification Agency), we focus on ISO 31000 to provide pioneering 
                services in corporate risk management. This standard offers companies a comprehensive 
                framework for dealing with uncertainties in the business world and maximizing opportunities.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ISO 31000?</h2>
            <div className="page-text-content">
              <p>
                ISO 31000 is a global reference point in the field of corporate risk management. It is 
                created to ensure that companies are effectively prepared for various risks. It helps 
                organizations standardize the processes of identifying, assessing, controlling, and 
                continuously improving risks.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Key Principles of ISO 31000</h2>
            <div className="principles-list">
              <div className="principle-item">
                <h3 className="principle-title">1. Integrated Approach</h3>
                <p className="principle-description">
                  The principle of integrating risk management into all processes of the organization.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">2. Comprehensive Assessment</h3>
                <p className="principle-description">
                  A broad assessment process covering financial, strategic, operational, and other types 
                  of risks.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">3. Continuous Improvement</h3>
                <p className="principle-description">
                  The principle of continuously reviewing and enhancing the risk management process.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">ISO 31000 Implementation Process</h2>
            <div className="process-list">
              <div className="process-item">
                <h3 className="process-title">1. Risk Identification</h3>
                <p className="process-description">
                  Identifying and cataloging potential risks.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">2. Risk Assessment</h3>
                <p className="process-description">
                  Evaluating the probabilities and impacts of risks.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">3. Risk Control</h3>
                <p className="process-description">
                  Bringing risks to acceptable levels.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">4. Monitoring and Improvement</h3>
                <p className="process-description">
                  Continuously reviewing and improving the risk management process.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Advantages of ISO 31000</h2>
            <div className="advantages-list">
              <div className="advantage-item">
                <h3 className="advantage-title">1. Strategic Assurance</h3>
                <p className="advantage-description">
                  ISO 31000 helps organizations make strategic decisions with confidence by providing a 
                  comprehensive framework for risk management.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">2. Operational Resilience</h3>
                <p className="advantage-description">
                  The standard enables organizations to build resilience against operational risks and 
                  maintain business continuity.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">3. Financial Stability</h3>
                <p className="advantage-description">
                  ISO 31000 helps organizations identify and manage financial risks, contributing to 
                  long-term financial stability.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">ISO 31000 and Sustainability</h2>
            <div className="page-text-content">
              <p>
                ISO 31000 plays a crucial role in building sustainable business models. By effectively 
                managing risks, organizations can ensure long-term success and contribute to 
                sustainable development. The standard helps businesses identify environmental, social, 
                and governance (ESG) risks and integrate them into their overall risk management strategy.
              </p>
              <p>
                For more information on ISO 31000 Enterprise Risk Management System and how it can 
                benefit your organization, feel free to contact us. NQC is here to help you build a 
                resilient and sustainable future.
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO31000;

